import React , {
    useState,
    useContext,
    useEffect
} from "react";
import Layout from "../components/layout";
import { ProductsContext } from "../context/products-context";
import { 
    Typography, 
    Box, 
    Container, 
    Grid 
} from "@mui/material";
import { grey } from "@mui/material/colors";
import ProductGallery from "../components/productGallery";
// import { useNavigate} from "react-router-dom";
// import Fake from "../components/fake";
// import { useTheme } from '@mui/material/styles';
// import CircularProgress from '@mui/material/CircularProgress';
import { Helmet } from "react-helmet";
// import IconBreadcrumbs from "../components/iconBreadCrumbs";
import PantryProgress from "../components/pantryCircularProgress";


const Shop = () => {

    const { products } = useContext(ProductsContext)
    const [loading, setLoading] = useState(true)
    const [oliveOils, setOliveOils] = useState([])
    const [specialties, setSpecialties] = useState([])
    const [vinegars, setVinegars] = useState([])

    useEffect( () => {

        if (products) {
            // console.log(products)
            const OO = []
            const SP = []
            const VN = []
            products.map( (product, index) => {
                if (product.attributes.length === 0) {
                    OO.push(product)
                } else {
                    if (product.attributes[0] === 'Specialty') {
                        SP.push(product)
                    } else {
                        if (product.attributes[0] === 'Vinegar') {
                            VN.push(product)
                        }
                    }
                }
                return null
            } )
            // console.log(OO)
            setOliveOils(OO)
            setSpecialties(SP)
            setVinegars(VN)
            setLoading(false)
        }

        return( () => {})
    }, [products])


    return(
        <div>
            <Helmet>
                <title>Shop the Pantry</title>
                <meta name="description" content={'The pantry bakery and catering provides unique culinary experience centered around locally sourced, fresh, and mostly organic ingredients'} />
                <meta name="keywords" content="novello, oilive oil, novello olive oil, italian olive oil, pantry, pantry bakery, pantry catering, event catering, plant-based catering, organic catering, authentic korean food catering, low fat lunch, low sodium lunch box, corporate catering, corporate lunch box, salt bread, korean salt bread, grazing box, Orange counry catering, Los Angeles catering, team building lunch catering, executive breakfast, corporate event catering, fresh, special event lunch box" />

                <meta property="og:title" content={'Shop the Pantry'} />
                <meta property="og:description" content={'The pantry bakery and catering provides unique culinary experience centered around locally sourced, fresh, and mostly organic ingredients'} />
                {/* <meta property="og:image" content={URL of the image you want to use} /> */}
                <meta property="og:url" content={'https://thepantry.catering/shop'} />
                <meta property="og:type" content="website" />

                <meta name="twitter:title" content={'Shop the Pantryp'}  />
                <meta name="twitter:description" content={'The pantry bakery and catering provides unique culinary experience centered around locally sourced, fresh, and mostly organic ingredients'} />
            </Helmet>
            <Layout>

                <Container maxWidth='md'>

                    {
                        loading ? 

                        <PantryProgress />

                        :

                        <Box>

                            <Box sx={{
                                display: 'flex', 
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center',
                                width: '100%',
                                minHeight: '55vh',
                                // height: '100%',
                                pt: '8rem',
                                pb: '3rem',
                                // background: 'teal'
                                }}>

                                {/* <Box sx={{display: 'flex', width: '100%'}}>
                                    <IconBreadcrumbs previous={'Home'} />
                                </Box> */}

                                {/* Header */}
                                <Box sx={{
                                    display: 'flex', 
                                    alignItems: 'center', 
                                    justifyContent: 'center',
                                    // background: 'red'
                                    }}>
                                    <Typography 
                                        textAlign={'center'} 
                                        sx={{
                                            fontFamily: 'Neuton',
                                            fontSize: {xs: 36, md: 48},
                                            lineHeight: 2,  
                                            fontWeight: 400,
                                            color: grey[800], 
                                            // pt: '4%',
                                            pb: {md: '1rem'},
                                            width: '100%', 
                                            height: '100%'}}>
                                        Shop the Pantry
                                    </Typography>
                                </Box>

                                {/* Sub Header */}
                                <Box sx={{
                                    display: 'flex', 
                                    alignItems: 'center', 
                                    justifyContent: 'center',
                                    pb: '1rem',
                                    }}>

                                    <Typography 
                                        textAlign={'center'} 
                                        sx={{
                                            fontFamily: 'Neuton',
                                            fontSize: {xs: 20, md: 24},
                                            fontWeight: 300,
                                            width: '100%', 
                                            height: '100%'}}>

                                            Behind every great dish stands a great cook with even greater well-stocked pantry. Fill yours with our curated selection of pantry essentials and specialty items.

                                    </Typography>
                                </Box>

                                                                {/* H2 Header - Pantry Items */}
                                                                <Grid 
                                    container
                                    justifyContent="center"
                                    rowSpacing={2}>

                                    <Grid 
                                        item 
                                        xs={10} 
                                        md={12} 
                                        sx={{
                                            mb: '1rem',
                                            mt: '1rem',
                                            }}>

                                        <Typography 
                                            textAlign={'left'} 
                                            sx={{
                                                fontFamily: 'Neuton',
                                                borderBottom: '0.15rem solid',
                                                fontSize: {xs: 24, md: 36},
                                                lineHeight: 1.5,  
                                                fontWeight: 400,
                                                color: grey[700], 
                                                width: '100%', 
                                                height: '100%'}}>
                                            Specialties
                                        </Typography>

                                    </Grid>

                                </Grid>

                                {/* Specialty Grid */}
                                <Grid 
                                    container 
                                    justifyContent="center"
                                    alignItems="center"
                                    rowSpacing={2} 
                                    columnSpacing={2}>

                                        {
                                            specialties.map(
                                                (product, index) => <ProductGallery key={index} payload={product}/>
                                            )
                                        }

                                </Grid>

                                {/* H2 Header - OO */}
                                <Grid 
                                    container
                                    justifyContent="center"
                                    rowSpacing={2}>

                                    <Grid 
                                        item 
                                        xs={10} 
                                        md={12} 
                                        sx={{
                                            mb: '1rem',
                                            }}>

                                        <Typography 
                                            textAlign={'left'} 
                                            sx={{
                                                fontFamily: 'Neuton',
                                                borderBottom: '0.15rem solid',
                                                fontSize: {xs: 24, md: 36},
                                                lineHeight: 1.5,  
                                                fontWeight: 400,
                                                color: grey[700], 
                                                width: '100%', 
                                                height: '100%'}}>
                                            Olive Oils
                                        </Typography>

                                    </Grid>

                                </Grid>

                                {/* OO Grid */}
                                <Grid 
                                    container 
                                    justifyContent="center"
                                    alignItems="center"
                                    rowSpacing={2} 
                                    columnSpacing={2}>

                                        {
                                            oliveOils.map(
                                                (product, index) => <ProductGallery key={index} payload={product}/>
                                                // (product, index) => product.attributes !== 'Specialty' ? <ProductGallery key={index} payload={product}/> : null
                                            )
                                        }

                                </Grid>

                                {/* H2 Header - Vinegars */}
                                <Grid 
                                    container
                                    justifyContent="center"
                                    rowSpacing={2}>

                                    <Grid 
                                        item 
                                        xs={10} 
                                        md={12} 
                                        sx={{
                                            mb: '1rem',
                                            mt: '1rem',
                                            }}>

                                        <Typography 
                                            textAlign={'left'} 
                                            sx={{
                                                fontFamily: 'Neuton',
                                                borderBottom: '0.15rem solid',
                                                fontSize: {xs: 24, md: 36},
                                                lineHeight: 1.5,  
                                                fontWeight: 400,
                                                color: grey[700], 
                                                width: '100%', 
                                                height: '100%'}}>
                                            Vinegars
                                        </Typography>

                                    </Grid>

                                </Grid>

                                {/* Vinegar Grid */}
                                <Grid 
                                    container 
                                    justifyContent="center"
                                    alignItems="center"
                                    rowSpacing={2} 
                                    columnSpacing={2}>

                                        {
                                            vinegars.map(
                                                (product, index) => <ProductGallery key={index} payload={product}/>
                                            )
                                        }

                                </Grid>

                            </Box>

                        </Box>

                    }

                </Container>

            </Layout>
        </div>
    )
}

export default Shop